<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <DataGetter
      v-if="isLoading"
      @dataAvailable="
        data => {
          stores = data?.metaData?.stores || []
          totalPages = Math.ceil(data?.metaData?.total / 12)
          this.isLoading = false
        }
      "
      :searchQuery="{ page: currentPage, limit: 12 }"
      contentId="stores"
      eventToListen="none"
    />
    <!-- {{ currentPage }}
    {{totalPages}} -->
    <DataGetter
      @dataAvailable="
        data => {
          storesStats = data?.metaData?.storesStats || {}
        }
      "
      contentId="storesStats"
    />
    <DataGetter
      @dataAvailable="
        data => {
          storesBalances = data?.metaData?.storesBalances || {}
        }
      "
      contentId="storesBalances"
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 bg-[#f4f4f5] pt-8 z-[2]"
    >
      <div class="text-4xl title-color">Boutiques</div>
    </div>
    <div v-if="isLoading || stores.length > 0">
      <div class="py-4"></div>

      <div class="py-4"></div>
      <div class="grid grid-cols-2 md:grid-cols-4 gap-8">
        <div
          :to="`/stores/${store.id}`"
          v-for="(store, i) in isLoading ? shimmerStores : stores"
          :key="i"
          class="border relative rounded-[2rem] flex flex-col  overflow-hidden p-8"
          :class="{
            'shimmerElement pointer-events-none': store.shimmer,
            'bg-secondary-100': i % 1 == 0,
            'bg-[#BBCEFF]': i % 2 == 0,
            'bg-[#BFEEFF]': i % 3 == 0,
            'bg-[#F6C8FF]': i % 4 == 0,
          }"
        >
          <div
            class="absolute right-4 top-6  flex items-center gap-2 justify-end !pointer-events-auto z-[2]"
            @click.stop="() => {}"
          >
            <DropdownComponent
              :selects="[
                {
                  name: 'Détail',
                  onClick() {
                    $router.push(`/stores/${store.id}`)
                  },
                },
                {
                  name: 'Changer processeur de carte',
                  onClick() {
                    changeCardProcessor(store)
                  },
                },
              ]"
              hideArrow
              maxHeight="270px"
              displayKey="name"
              toLeft
              :onSelect="
                selected => {
                  selected.onClick()
                }
              "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="#2c2c2c"
                class="w-8 h-8 "
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                />
              </svg>
            </DropdownComponent>
          </div>

          <div class="w-full flex  relative">
            <div class="w-16 h-16">
              <img
                :src="store.logo"
                class="object-cover bg-white w-full h-full p-1  overflow-hidden rounded-[1.2rem]"
                alt=""
              />
            </div>
          </div>
          <div class="py-4"></div>
          <div class="title-color  text-xl md:text-2xl font-bold  truncate">
            {{ store.storeName||'-' }}
          </div>
          <div class="py-1"></div>
          <div class="title-color text-xs md:text-sm">
            Créé le
            {{
              store.createdAt
                ? $Commons.timestampToDate(store.createdAt, ' DD MMM YYYY')
                : '-'
            }}
          </div>
          <!-- <div class="py-2"></div> -->
          <div class="flex flex-col px-6 gap-2" v-if="false">
            <div class="flex justify-between">
              <div>Solde Disponible</div>
              <div class="font-bold title-color">
                {{ storesBalances[store.id]?.balance }} FCFA
              </div>
            </div>

            <div class="flex justify-between">
              <div>Solde D'opération</div>
              <div class="font-bold title-color">
                {{ storesBalances[store.id]?.pendingBalance }} FCFA
              </div>
            </div>
            <div></div>
            <div class="font-bold">Cette année:</div>

            <div class="flex justify-between">
              <div>Chiffre d'affaire</div>
              <div class="font-bold title-color">
                {{ storesStats[store.id]?.paymentDoneStats?.amount }} FCFA
              </div>
            </div>

            <div class="flex justify-between">
              <div>Nb Commandes payé</div>
              <div class="font-bold title-color">
                {{ storesStats[store.id]?.orderStats?.count }}
              </div>
            </div>

            <div class="flex justify-between">
              <div>Nb nouveaux clients</div>
              <div class="font-bold title-color">
                {{ storesStats[store.id]?.customerStats?.count }}
              </div>
            </div>

            <div class="flex justify-between">
              <div>Nb paiement échoué</div>
              <div class="font-bold title-color">
                {{ storesStats[store.id]?.paymentFailedStats?.count }}
              </div>
            </div>
            <!-- 
            <div @click.stop.prevent="()=>{}">

              <InputComponent
                type="toggle"
                :value="store.cardProcessor == 'stripe'"
              />
            </div> -->
          </div>
          <!-- <div class="py-2"></div> -->
          <!-- {{ store }} -->
        </div>
      </div>
      <div class="py-4"></div>
      <div class="flex justify-center">
        <Pagination
          v-if="!isLoading"
          :currentPage="currentPage"
          :totalPages="totalPages"
          @pageClick="newPage => (currentPage = newPage)"
        />
      </div>
    </div>
    <div
      class="h-[60vh] w-full flex-col items-center justify-center flex"
      v-else
    >
      <div class="w-1/5">
        <img src="@/assets/images/empty/no-order.png" alt="" />
      </div>
      <div class="py-1"></div>
      <div class="text-center">
        <div class="py-1"></div>
        <div class="text-4xl title-color font-bold">
          Aucune boutique en disponible
        </div>
        <div class="py-1"></div>
        <div class="text-lg">Vous n'avez aucune boutique. <br /></div>
        <div class="py-3"></div>
        <div class="flex justify-center gap-6">
          <router-link to="/products" class="buttonComponent">
            Créer ou partager des produits
          </router-link>
        </div>
      </div>
    </div>
    <EventListener
      :events="['failed_to_save_store_data', 'store_data_saved']"
      @failed_to_save_store_data="onStoreDataNotSaved"
      @store_data_saved="onStoreDataSaved"
    />
  </div>
</template>

<script>
import DataGetter from '@/components/utils/DataGetter.vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'
import Pagination from '@/components/utils/Pagination.vue'

export default {
  name: 'homeComponent',
  components: { DataGetter, EventListener, Pagination, DropdownComponent },
  data() {
    return {
      eventsIds: [],
      stores: [],
      storesStats: {},
      storesBalances: {},
      activeTab: 'home',
      isLoading: true,
      totalPages: 0,
      currentPage: 1,
      shimmerStores: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
      statuses: {
        all: { id: 'all', name: 'Tout' },
        initial: {
          id: 'initial',
          name: 'Paiement en cours',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        paid: {
          id: 'paid',
          name: 'Payé',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        paymentFailed: {
          id: 'failed',
          name: 'Paiement échoué',
          background: '#EEF2F3',
          color: '#696969',
        },
        processing: {
          id: 'processing',
          name: 'Livraison en cours',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        delivered: {
          id: 'delivered',
          name: 'Délivré',
          background: '#EAEEFF',
          color: '#2930B5',
        },
        refunded: { id: 'refunded', name: 'Rémboursé' },
        // failed: {
        //   id: 'failed',
        //   name: 'Echoué',
        //   background: '#EEF2F3',
        //   color: '#696969',
        // },
      },
      paymentMethods: {
        card: 'Carte bancaire',
        mobileMoney: 'Mobile Money',
      },
      activeStatus: 'all',
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {},
  methods: {
    async changeCardProcessor(store) {
      const options = {
        'qos-page': { title: 'Qos', id: 'qos-page' },
        'kkiapay-page': { title: 'Kkiapay', id: 'kkiapay-page' },
        'stripe-page': { title: 'Stripe', id: 'stripe-page' },
        cinetpay: { title: 'Cinetpay', id: 'cinetpay' },
        '': { title: 'Processeur par défaut', id: '' },
      }

      let message = 'Cette boutique utiliser les processeurs par défaut'
      if (store.cardProcessor) {
        message = `<span class="description-color">Les paiements par carte de cette boutique sont configuré sur <span class="title-color font-bold">${options[store.cardProcessor].title}</span></span>`
      }
      const prompt = await window.choicePrompt({
        title: 'Sélectionner le processeur de paiement à utiliser',
        subTitle: message,
        options: Object.values(options),
        formatDisplay: data => data?.title || '',
        cancelText: 'Retour',
        successText: 'Configurer',
      })
      if (!prompt.accepted || !prompt.data) return null

      await new Promise(r => setTimeout(r, 500))
      store.cardProcessor = prompt.data.id
      this.$Events.dispatchEvent('store_preferences_setted', store)

      this.$Events.dispatchEvent('start_loading', {
        title: 'Enrégistrement en cours',
      })
    },

    onStoreDataNotSaved() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Échoué',
        body: "Nous rencontrons des problèmes lors de l'enrégistrement, veuillez réessayer",
      })
    },
    onStoreDataSaved() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Réussi',
        body: 'Les informations ont été renrégistrées correctement.',
      })
      this.isLoading = true
    },
  },
  watch: {
    currentPage() {
      this.isLoading = true
    },
  },
}
</script>
